import { Button } from '@breetometer/components';
import { classNameMerger } from '@breetometer/utils';
import { useCallback } from 'react';

import type { ITabHeader } from '../Tab.helpers';

const TabHeaderPills = <T extends string>({ tabs, onTabClick, setActiveTab, activeTab }: ITabHeader<T>) => {
	const handleTabClick = useCallback(
		(tabItem: T) => () => {
			onTabClick?.(tabItem);
			setActiveTab(tabItem);
		},
		[onTabClick, setActiveTab]
	);

	const firstTab = tabs[0];
	const lastTab = tabs[tabs.length - 1];

	return (
		<div className='tab_header pills'>
			{tabs.map((tabItem) => (
				<Button
					variant='native'
					key={tabItem}
					type='button'
					className={classNameMerger(
						'tab_header_button',
						activeTab === tabItem ? 'active bg-primary-400 border-primary-400' : 'color-primary-300 border-primary-400',
						tabItem === firstTab && 'left',
						tabItem === lastTab && 'right'
					)}
					onClick={handleTabClick(tabItem as T)}
				>
					{tabItem}
				</Button>
			))}
		</div>
	);
};

export default TabHeaderPills;
